'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var toISODateString = {};

exports.__exports = toISODateString;
